import { Feature, FeatureCollection, Point } from 'geojson';
import SingletonEventEmitterClass from '../../classes/SingletonEventEmitterClass';
import { findList, audit, findById } from '../../api/operation/adjustment';

export default class AdjustmentLoader extends SingletonEventEmitterClass {
  private _data: any[] = [];
  private _center?: ILngLat = undefined;

  public get unFinishedGeojson(): FeatureCollection<Point> {
    return {
      type: 'FeatureCollection',
      features: this._data.length ? this._data.filter(i => i.state === (window as any).constants.OP_PARKING_ADJUSTMENT_ITEMS.待处理).map<Feature<Point>>(point => {
        return {
          type: 'Feature',
          geometry: point.location.lngLat.geometry!,
          properties: {
            id: point._id,
            info: {
              ...point, layerType: 'adjustment',
            },
          },
        };
      }) : [],
    };
  }

  public get finishedGeojson(): FeatureCollection<Point> {
    return {
      type: 'FeatureCollection',
      features: this._data.length ? this._data.filter(i => i.state === (window as any).constants.OP_PARKING_ADJUSTMENT_ITEMS.已完成).map<Feature<Point>>(point => {
        return {
          type: 'Feature',
          geometry: point.location.lngLat.geometry!,
          properties: {
            id: point._id,
            info: {
              ...point, layerType: 'adjustment',
            },
          },
        };
      }) : [],
    };
  }

  public async audit(adjustmentId: string, remark: string) {
    await audit(adjustmentId, remark);
    this._triggerUpdate();
  }

  public onMapUpdatedCenter(center: ILngLat, state: number) {
    this._center = center;
    this._fetchData(state);
  }

  public async findById(adjustmentId: string) {
    const { data } = await findById(adjustmentId);
    return data;
  }

  private async _fetchData(state: number) {
    const { data } = await findList(this._center as ILngLat, 20000, state);
    this._data = data.items!;
    this._triggerUpdate();
  }

  private _triggerUpdate() {
    this.emit('updated');
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/AdjustmentLoader.ts